import { render, staticRenderFns } from "./createvouch.vue?vue&type=template&id=23e01fcf&scoped=true&"
import script from "./createvouch.vue?vue&type=script&lang=js&"
export * from "./createvouch.vue?vue&type=script&lang=js&"
import style0 from "./createvouch.vue?vue&type=style&index=0&id=23e01fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e01fcf",
  null
  
)

export default component.exports